module.exports = __webpack_public_path__ + "media/images/visa-partner-5ebb873a.svg";